import { type RespondedAssessment } from "../trustAPI";
import { DynamicForm } from "../../dynamicForm";
import { Drawer } from "../../shared/Drawer";
import { AssessmentDrawerHeader } from "./AssessmentDrawerHeader";

type ResponsedDrawerContentProps = { assessment: RespondedAssessment };

export const ResponsedDrawerContent = ({ assessment }: ResponsedDrawerContentProps) => {
  return (
    <DynamicForm.Provider key={assessment.id} isReadOnly={true} answers={assessment.answersSnapshot}>
      <AssessmentDrawerHeader title={assessment.requestedBy.organisation.name} />
      <Drawer.Content>
        <DynamicForm.InlineForm variant="secondary" id={assessment.id} form={assessment.formSnapshot} />
      </Drawer.Content>
    </DynamicForm.Provider>
  );
};
